<template>
   <div class="toast-wrapper">
      <div
         v-for="toast in toastsList"
         :key="toast.id"
         class="toast"
         :class="[toast.status]"
      >
         <div class="toast-message">
            <p class="emoji" v-html="toast.messageEmoji"></p>
            <span v-html="toast.message"></span>
         </div>

         <div class="toast-buttons">
            <Btn
               v-if="toast.isToastButton"
               class="toast-comment-btn text-link"
               :class="{
                  teal: toast.status === 'success',
                  red: toast.status === 'error',
                  yellow: toast.status === 'warning',
               }"
               @click="($event) => handleToastAction(toast, $event)"
            >
               {{ toast.toastButtonText }}
            </Btn>

            <IconCross class="toast-close-btn" @click="handleClose(toast)" />
         </div>
      </div>
   </div>
</template>

<script setup lang="ts">
import IconCross from "~/assets/images/icons/cross.svg?component";
const { toastsList, removeToast } = useToast();

const props = defineProps({
   toastsList: {
      type: Array,
      default: () => [],
   },
});

const handleToastAction = (toast, event) => {
   removeToast(toast.id);
   toast?.callback && toast.callback();
};

const handleClose = (toast) => {
   removeToast(toast.id);
};
</script>
<style lang="scss" scoped>
@import url("~/assets/scss/toast-wrapper.scss");
</style>
